import { render } from "./VenueUser.vue?vue&type=template&id=771064f8"
import script from "./VenueUser.vue?vue&type=script&lang=js"
export * from "./VenueUser.vue?vue&type=script&lang=js"
script.render = render

export default script